import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Trebuchet",
  "description": "",
  "published": "2006-11-01T00:00:00.000Z",
  "redirect_from": ["/blog/trebuchet/swizec/374"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/trebuchet.jpg"
      }}><img parentName="a" {...{
          "src": "/includes/editor_upload/Image/trebuchet_thumb.jpg",
          "alt": "Trebuchet",
          "title": "Trebuchet"
        }}></img></a></p>
    <p>{`Well, here's the first of the daily blog days, hopefully these will not be a problem to write, because usually there isn't much to say, but hey, things can be made more interesting, that's what nano is about anyway is it not? Well, the image above is a link to a collage with crappy photos of the lego trebuchet I built in the last few days and spent quite some time tweaking it today.`}</p>
    <p>{`As you can see, it's not the biggest trebuchet in existence, but it is quite tall and it happens to pack a punch unseen in my room before. The counter weight is right now filled with coins but I'll probably go buy some fishing lead tomorrow and fill it with that, reckon that will give me a weight of about 2 kilo. The range right now is about 5 meters for a block of four regular 2x4 lego bricks, which appears to be the optimum amunition.`}</p>
    <p>{`I stumbled upon a very amusing `}<a parentName="p" {...{
        "href": "http://jenwang.net/art/comics/touchfood/"
      }}>{`little comic`}</a>{` today, which I think you should go see because well, it's just awesome. You might also like to check out `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=pages/submode=NaNoWriMo"
      }}>{`this`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      